import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, TextField } from '@material-ui/core';
import { useStyles } from '../login/LoginPage';
import authService from '../../../services/AuthService/AuthService';
import { useSetRecoilState } from 'recoil';
import { alertState } from '../../../recoil-store/recoil-state';

/**
 * @Description This function lets you return Reset Password page.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function ResetPassword(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const label = 'CONTENT.AUTH-PAGES.';
    const [loading, setLoading] = useState(true);
    const userId = useRef('');
    const setAlert = useSetRecoilState(alertState);

    const history = useNavigate();
    useEffect(() => { fetchData(); }, []);

    const fetchData = async () => {
        const response = await authService.verifyResetPassword(props.match.params.hash);
        if (!response) {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
        } else if (response.status) {
            userId.current = response.data.user_id;
            setLoading(false);
        } else {
            redirectLogin();
            let message = t('MESSAGES.AUTH-PAGES.RESET-PAGE.' + response.message);
            let severity = response.status ? 'success' : 'error';
            setAlert(alert => ({ ...alert, show: true, message: message, severity: severity }))
        }
    }
    const redirectLogin = () => {
        setTimeout(() => { history('/login'); }, 2000);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const response = await authService.resetPassword({
            confirmPassword: e.target.confirmPassword.value,
            newPassword: e.target.newPassword.value,
            hashCode: props.match.params.hash,
            userId: userId.current
        });
        if (response) {
            let message = t('MESSAGES.AUTH-PAGES.RESET-PAGE.' + response.message);
            let severity = response.status ? 'success' : 'error';
            setAlert(alert => ({ ...alert, show: true, message: message, severity: severity }))
            if (response.status) { redirectLogin(); }
        } else {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
        }
    };

    return (
        <div className="login-page">
            <form onSubmit={handleSubmit} className="login-container forgot">
                <div className="login-autommate"></div>
                <div></div>
                <div className="login-seperator"><div></div><div>{t(label + 'FORGOT-PASSWORD-TITLE')}</div><div></div></div>
                <div>
                    <div className="login-label">
                        <div>{t(label + 'RESET-PASSWORD-TITLE')} *</div>
                        <TextField classes={{ root: classes.text }} variant="outlined" fullWidth name="newPassword" placeholder={t(label + 'NEW-PASSWORD')} />
                    </div>
                    <div className="login-label">
                        <div>{t(label + 'RESET-PASSWORD-AGAIN')} *</div>
                        <TextField classes={{ root: classes.text }} variant="outlined" fullWidth name="confirmPassword" placeholder={t(label + 'NEW-PASSWORD-AGAIN')} />
                    </div>
                    <div className="login-option">
                        <div></div>
                        <Link to="/login">{t(label + 'BACK-TO-LOGIN')}</Link>
                    </div>
                </div>
                <Button style={{ backgroundColor: '#031226', color: '#fff', width: 160, padding: '9px 0' }} disabled={loading} type="submit">
                    <span className="login-signin">{t(label + 'RESET-PASSWORD')}</span>
                </Button>
            </form>
            <div className="login-right">
                <div>{t(label + 'AUTOMATE')}</div>
                <div>{t(label + 'WITHOUT-CODE')}</div>
                <div>{t(label + 'INTEGRATING')}</div>
            </div>
        </div>
    );
}

export default ResetPassword;